import React from 'react';

const getOrder = (width) => {
  const obj = {
    cellProps: {
      Header: () => <span className="filter-title">ORDER</span>,
      Cell: (props) => {
        return (
          <>
            <span className="rt-td__head">ORDER</span>
            <div className={'rt-td__cell'}>
              <div className="orders-tab-order-container">
                <span className="orders-tab-order title">{props.row.order.title}</span>
                <span className="orders-tab-order desc">{props.row.order.desc}</span>
              </div>
            </div>
          </>
        );
      },
      accessor: 'order',
      sortable: false,
    },
  };
  if (width) obj.cellProps.width = width;
  return obj;
};

const getInvoice = (width) => {
  const obj = {
    cellProps: {
      Header: () => <span className="filter-title">INVOICE</span>,
      Cell: (props) => {
        return (
          <>
            <span className="rt-td__head">INVOICE</span>
            <div className={'rt-td__cell'}>
              <div className="opentab-invoice-container">
                <span className="opentab-invoice title">{props.row.invoice.title}</span>
                <span className="opentab-invoice desc">{props.row.invoice.desc}</span>
              </div>
            </div>
          </>
        );
      },
      accessor: 'invoice',
      sortable: false,
    },
  };
  if (width) obj.cellProps.width = width;
  return obj;
};

const getIssued = (width) => {
  return {
    title: 'ISSUED',
    cellProps: {
      accessor: 'issued',
      width,
      sortable: false,
    },
  };
};

const getDueDate = (width) => {
  return {
    title: 'DUE DATE',
    cellProps: {
      accessor: 'due_date',
      width,
      sortable: false,
    },
  };
};

const getPaidDate = (width) => {
  return {
    title: 'PAID DATE',
    cellProps: {
      accessor: 'paid_date',
      width,
      sortable: false,
    },
  };
};

const getTotal = (width) => {
  return {
    title: 'TOTAL',
    cellProps: {
      accessor: 'total',
      width,
    },
  };
};

const getBalance = (width) => {
  return {
    title: 'BALANCE',
    cellProps: {
      accessor: 'balance',
      width,
    },
  };
};

const getInvoices = (width, redirectInvoices) => {
  return {
    cellProps: {
      Header: () => <span className="filter-title">INVOICE</span>,
      Cell: (props) => {
        return (
          <>
            <span className="rt-td__head">INVOICE</span>
            <div className={'rt-td__cell'}>
              <div className="orders-tab-invoices__container">
                {props.row.invoices.map((item) => (
                  <div key={item.id} className="invoices-badge"
                       onClick={(event) => redirectInvoices(event, item.id)}
                       data-testid={`invoice-link${item.id}`}>
                    {item.reference}
                  </div>
                ))}
              </div>
            </div>
          </>
        );
      },
      accessor: 'invoices',
      width,
      sortable: false,
    },
  };
};

const getRequested = (width) => {
  return {
    title: 'REQUESTED',
    cellProps: {
      accessor: 'requested',
      width,
      sortable: false,
    },
  };
};

export {
  getOrder,
  getIssued,
  getBalance,
  getDueDate,
  getPaidDate,
  getInvoices,
  getInvoice,
  getTotal,
  getRequested
};
